/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Payment_Filter_ToInputs */

const vi_grower_payment_filter_to = /** @type {(inputs: Grower_Payment_Filter_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến ngày`)
};

/**

* @param {Grower_Payment_Filter_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_payment_filter_to = /** @type {((inputs?: Grower_Payment_Filter_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Payment_Filter_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_payment_filter_to(inputs)
});